///EDITADO

// import { useEffect }		 				from "react"
// import { useJustificationPage }       		from "../contexts/JustificationPageContext"
// import { useUser }                 			from '../contexts/UserContext.js'
// import { findPermission }          			from '../utils/UserPermissionUtils.js'
// import { useNavigate }             			from 'react-router-dom'

// import JustificationPageFilter        		from "../components/Filters/JustificationPageFilter"
// import ComparisionTypeFilter				from "../components/Filters/ComparisionTypeFilter.js"

// import JustificationFileFormContainer		from "../components/Form/JustificationFileFormContainer.js"
// import JustificationListModalContainer		from "../components/Modals/JustificationListModalContainer.js"
// import JustificationFormContainer			from "../components/Form/JustificationFormContainer.js"	

// import ComparisionTableContainer    		from "../components/Table/ComparisionTableContainer" 

// import  { ReactComponent as IconUpload }  	from '../assets/Icons/icon-upload.svg'
// import  { ReactComponent as IconExcel  }  	from '../assets/DemandTableModal/excel.svg'

// import '../styles/main.css'
// import '../styles/JustificationPage.css'

// import api                                  from "../services/api"

// function JustificationPage() {
  
//     const { 

// 		handerOpenJustificationFileForm, 
// 		setComparisionTypes, 
// 		setSelectedComparisionTypeId,

// 		selectedComparisionTypeId,
// 		selectedComparisionDate, 

// 	} = useJustificationPage()

// 	const { 
		
// 		userData, 
// 		token
	
// 	} = useUser()

// 	const navigate = useNavigate()

// 	const getAllComparisionTypes = async () => {
        
//         const response = await api.get('/getAllComparisionTypes', {
// 			headers: { Authorization: `Bearer ${token}` }
// 		})
		
// 		setComparisionTypes(response.data)
// 		setSelectedComparisionTypeId(response.data[0]?.id || null)
    
// 	}

// 	const downloadExcelBase = async () => {

// 		try {

// 			const response = await api.get(`/getComparisionPostExcelById`,{
					
// 				responseType: 'blob',
// 				params: {
						
// 					comparisionTypeId: selectedComparisionTypeId,
// 					comparisionDate: selectedComparisionDate
// 				}}
// 			)

// 			const url  = window.URL.createObjectURL(new Blob([response.data]))
// 			const link = document.createElement('a')

// 			link.href = url
// 			link.setAttribute('download', 'planilha.xlsx')

// 			document.body.appendChild(link)
// 			link.click()
// 			link.remove()

// 		}catch(error){

// 			console.log('❌ JustificationPage - downloadExcelBase', error)

// 		}

// 	}

// 	useEffect(() => {

//         if (!userData?.permissions) return
    
//         const hasPermission = findPermission(userData, "Acesso à Pagina de Justificativas")

//         if (!hasPermission) navigate("/home")
        
// 		getAllComparisionTypes()
    
//     }, [userData, navigate])
    
//     return (

//       	<div className="pg-content">  

// 			<JustificationListModalContainer/>
// 			<JustificationFileFormContainer/>
// 			<JustificationFormContainer/>

// 			<header>

// 				<h1 className="mb-5">
// 					Árvore de Justificativas
// 				</h1>

// 				<section className="w-full bg-neutro borda-cinza rounded-[7px] p-4 flex justify-between gap-[10px]">
					
// 					<JustificationPageFilter />
					
// 					<div className="flex flex-row gap-2 ">
						
// 						<button
// 							className="btn btn-letra-verde !px-[11px] flex flex-row gap-2 "
// 							onClick={downloadExcelBase}
// 						>

// 							Baixar Base
// 							<IconExcel/>

// 						</button>

// 						{findPermission(userData, "Editar Justificativas") && (
							
// 							<button
// 								className="btn btn-transparente-amarelo !px-[11px] flex flex-row gap-2 items-center"
// 								onClick={handerOpenJustificationFileForm}
// 							>
// 								Enviar Arquivo
// 								<IconUpload className="p-[1px]"/>

// 							</button>
// 						)}

// 					</div>

// 				</section>

// 			</header>

// 			<ComparisionTypeFilter />

// 			<div>
// 				<ComparisionTableContainer />
// 			</div> 

//       </div>

//     )
// }

// export default JustificationPage


import { useEffect, useCallback }       from "react" // 🔴 ALTERADO: adicionei useCallback
import { useJustificationPage }         from "../contexts/JustificationPageContext"
import { useUser }                      from '../contexts/UserContext.js'
import { findPermission }               from '../utils/UserPermissionUtils.js'
import { useNavigate }                  from 'react-router-dom'

import JustificationPageFilter          from "../components/Filters/JustificationPageFilter"
import ComparisionTypeFilter            from "../components/Filters/ComparisionTypeFilter.js"

import JustificationFileFormContainer   from "../components/Form/JustificationFileFormContainer.js"
import JustificationListModalContainer  from "../components/Modals/JustificationListModalContainer.js"
import JustificationFormContainer       from "../components/Form/JustificationFormContainer.js"

import ComparisionTableContainer        from "../components/Table/ComparisionTableContainer"

import { ReactComponent as IconUpload } from '../assets/Icons/icon-upload.svg'
import { ReactComponent as IconExcel }  from '../assets/DemandTableModal/excel.svg'

import '../styles/main.css'
import '../styles/JustificationPage.css'

import api from "../services/api"

function JustificationPage() {

    const {

        handerOpenJustificationFileForm,
        setComparisionTypes,
        setSelectedComparisionTypeId,

        selectedComparisionTypeId,
        selectedComparisionDate,

    } = useJustificationPage()

    const {

        userData,
        token

    } = useUser()

    const navigate = useNavigate()

    const getAllComparisionTypes = useCallback(async () => { // 🔴 ALTERADO: envolvi em useCallback

        const response = await api.get('/getAllComparisionTypes', {
            headers: { Authorization: `Bearer ${token}` }
        })

        setComparisionTypes(response.data)
        setSelectedComparisionTypeId(response.data[0]?.id || null)

    }, [token, setComparisionTypes, setSelectedComparisionTypeId]) 
    
    // 🔴 ALTERADO: dependências da função

    const downloadExcelBase = async () => {
        
        try {
            const response = await api.get(`/getComparisionPostExcelById`, {
                responseType: 'blob',
                params: {
                    comparisionTypeId: selectedComparisionTypeId,
                    comparisionDate: selectedComparisionDate
                }
            });

            // ✅ pega o header
            const contentDisposition = response.headers['content-disposition'];

            let fileName = 'arquivo.xlsx'; // fallback

            if (contentDisposition) {
                const match = contentDisposition.match(/filename="?(.+?)"?$/);
                
                if (match?.[1]) {
                    fileName = match[1];
                }
            }

            // ✅ cria download
            const url  = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');

            link.href = url;
            link.setAttribute('download', fileName);

            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url); // boa prática

        } catch (error) {
            console.log('❌ JustificationPage - downloadExcelBase', error);
        }
    };

    useEffect(() => {

        if (!userData?.permissions) return

        const hasPermission = findPermission(userData, "Acesso à Pagina de Justificativas")

        if (!hasPermission) navigate("/home")

        getAllComparisionTypes()

    }, [userData, navigate, getAllComparisionTypes]) 
    // 🔴 ALTERADO: adicionei getAllComparisionTypes nas dependências

    return (

        <div className="pg-content">

            <JustificationListModalContainer />
            <JustificationFileFormContainer />
            <JustificationFormContainer />

            <header>

                <h1 className="mb-5">
                    Árvore de Justificativas
                </h1>

                <section className="w-full bg-neutro borda-cinza rounded-[7px] p-4 flex justify-between gap-[10px]">

                    <JustificationPageFilter />

                    <div className="flex flex-row gap-2 ">

                        <button
                            className="btn btn-letra-verde !px-[11px] flex flex-row gap-2 "
                            onClick={downloadExcelBase}
                        >

                            Baixar Base
                            <IconExcel />

                        </button>

                        {findPermission(userData, "Editar Justificativas") && (

                            <button
                                className="btn btn-transparente-amarelo !px-[11px] flex flex-row gap-2 items-center"
                                onClick={handerOpenJustificationFileForm}
                            >
                                Enviar Arquivo
                                <IconUpload className="p-[1px]" />

                            </button>
                        )}

                    </div>

                </section>

            </header>

            <ComparisionTypeFilter />

            <div>
                <ComparisionTableContainer />
            </div>

        </div>

    )
}

export default JustificationPage